var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.showed)?_c('el-form-item',{attrs:{"label":_vm.item.label,"prop":`${_vm.item.field}`,"hidden":_vm.item.options.hidden,"rules":[
    {
      required: _vm.item.required || false,
      message: _vm.item.label + '为必填字段',
    },
  ]}},[_c('el-cascader',{style:({ width: _vm.item.options.width }),attrs:{"options":_vm.item.options.valueData},model:{value:(_vm.$attrs.model[_vm.item.field]),callback:function ($$v) {_vm.$set(_vm.$attrs.model, _vm.item.field, $$v)},expression:"$attrs.model[item.field]"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }